import { Box, Divider } from '@chakra-ui/react';
import styled from '@emotion/styled';
import Button from '@molecules/Button';
import ModalComponent, { ModalProps } from '@molecules/BEOffScreen/Modal';
import RoomBed from '@view/components/Cards/RoomBed';
import Accommodation from '@data/models/Accommodation';
import useFormat from '@business/utils/hooks/useFormat';

const StyledButton = styled(Button)`
  border: 2px solid #32C0A0;
  font-weight: 500;
  font-size: 14px;
`;

interface ModalSelectIndividualProps extends ModalProps {
  accommodation: Accommodation;
  checkin: Date;
  checkout: Date;
}

const ModalSelectIndividual = ({
  accommodation,
  checkin,
  checkout,
  ...props
}: ModalSelectIndividualProps) => {
  const { isPrivate, accommodations } = accommodation;
  const { date } = useFormat();

  return (
    <ModalComponent
      {...props}
      title={`Select ${isPrivate ? 'Accommodation' : 'Bed'}`}
      subtitle={`${accommodation.title}, ${date(checkin)} - ${date(checkout)}`}
      buttons={(props) => (
        <StyledButton onClick={props.onCancel} color="black" variant="outline">
          Close
        </StyledButton>
      )}
      width={960}
      bodyPadding={false}
    >
      {accommodations.map((unit, index) => (
        <Box key={`${unit.name}-${index}`}>
          <RoomBed
            accommodation={accommodation}
            unit={unit}
            key={`${unit.name}-${index}`}
          />
          <Divider />
        </Box>
      ))}
    </ModalComponent>
  );
};

export default ModalSelectIndividual;
